import { AxiosError } from "axios";

type Jsonable =
  | string
  | number
  | boolean
  | null
  | undefined
  | readonly Jsonable[]
  | { readonly [key: string]: Jsonable }
  | { toJSON(): Jsonable };

export class BaseError extends Error {
  public readonly context?: Jsonable;

  constructor(
    message: string,
    options: { error?: Error; context?: Jsonable; cause?: Jsonable } = {},
  ) {
    const { cause, context } = options;

    super(message, { cause });
    this.name = this.constructor.name;

    this.context = context;
  }

  public static fromAxiosError(error: AxiosError) {
    return new BaseError(error.message, {
      context: {
        place: error.config?.url,
        status: error.response?.status,
        response: error.response?.data as { error: string } | string,
      },
      cause: error.message,
    });
  }

  public static fromError<T extends Error>(error: T) {
    return new BaseError(error.message, {
      context: { name: error.name, place: error.stack },
      cause: error.message,
    });
  }
}

export type AxiosBaseErrorContext = {
  place: string;
  status: number;
  response: string | { error: string } | boolean;
};

export const GENERIC_ERROR =
  "There was an error processing your request, please try again later";
